import React from 'react';
import {SearchField} from '../inputs/search/SearchField';
import styled from 'styled-components';
import Grid from '@material-ui/core/Grid/Grid';
import {AccentColorOptions} from 'epic-ue-theme';
import {FiltersBarDesktopProps} from './FiltersBarDesktop';
import {MenuIcon} from '../icons/MenuIcon';
import {Typography} from '../typography';

export interface FiltersBarMobileProps<T> extends FiltersBarDesktopProps<T> {
    filterLabel?: string;
    mobileSearchLabel?: string;
    searchLabel?: string;
    setSearch: (value: string) => void;
    setOpenedFilterBarMobile: (b: boolean) => void;
    resultsList?: any[];
}

const MobileFiltersBar = styled.div<{accentColor: AccentColorOptions}>`
    background-color: ${(p) => p.theme.palette.common.white};
    display: inline-block;
    cursor: pointer;
    width: 100%;

    text-align: center;
    width: 100%;

    .search-field {
        div,
        input {
            background-color: ${(p) => p.theme.palette.common.white};
        }

        .ue-icon-search {
            height: 16px;
            color: ${(p) => p.theme.palette.accent[p.accentColor]};
            margin: 0;
        }
    }

    .search {
        display: inline-flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        text-align: center;
        width: 160px;
    }

    .toggleCheckboxFilterButton {
        border-right: 1px solid ${(p) => p.theme.palette.neutral.silver};
        font-size: 14px;
    }

    input {
        background-color: ${(p) => p.theme.palette.common.white};
        outline: none;
        width: 100%;
        border: 0px;
        font-size: 14px;
    }

    .toggleCheckboxFilterButton,
    .toggleSearchButton {
        width: 100%;
        height: 100%;
        display: inline-flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-content: center;
        justify-content: center;
        align-items: center;
        text-align: center;
        svg {
            cursor: pointer;
            font-size: 22px;
            path {
                fill: ${(p) => p.theme.palette.accent[p.accentColor]};
            }
        }
        input {
            font-size: 16px;
            padding: 6px 10px;
            width: 80%;
        }
    }

    .toggleSearchButton {
        padding-left: 25%;
        svg {
            padding-right: 6px;
        }
    }
    .toggleCheckboxFilterButton svg {
        display: flex;
        align-self: flex-end;
        font-size: 22px;
        height: 100%;
        padding-right: 8px;
    }

    ${(p) => p.theme.breakpoints.down('sm')} {
        .filters-bar,
        .filters-search-bar {
            display: none;
        }
        .filters-bar.opened-mobile,
        .filters-search-bar.opened-mobile {
            display: block;
        }

        display: block;
        padding: 6xp 10px;
        font-size: 16px;
    }
`;

const FilterResultsCount = styled.div`
    text-align: center;
    margin-top: 15px;
`;

export const FiltersBarMobile = <T,>({
    setOpenedFilterBarMobile,
    filterLabel,
    totalCount,
    totalCountIsPreferredCount,
    mobileSearchLabel = 'Search',
    search,
    setSearch,
    onFilterSelect,
    filteredDataLabel = 'item',
    filteredDataLabelPlural = 'items',
    accentColor = 'sky',
    resultsList
}: FiltersBarMobileProps<T>): JSX.Element => {

    //when totalCountIsPreferredCount is false (default), fallback on  resultsList?.length if totalCount is undefined
    const count = totalCountIsPreferredCount ? totalCount : totalCount || resultsList?.length;

    return (
        <div className="mobile-filter-section">
            <MobileFiltersBar className="toggleFiltersSection" accentColor={accentColor}>
                <Grid container direction="row">
                    <Grid item xs={6} sm={6}>
                        <div
                            className="toggleCheckboxFilterButton"
                            role="button"
                            tabIndex={0}
                            onClick={() => {
                                setOpenedFilterBarMobile(true);
                            }}>
                            <MenuIcon /> {filterLabel || 'Filter'}
                        </div>
                    </Grid>
                    <Grid item xs={6} sm={6}>
                        <div className="search">
                            <SearchField
                                onChange={(searchText) => {
                                    setSearch(searchText);
                                    onFilterSelect({search: searchText});
                                }}
                                searchLabelText={mobileSearchLabel || `Find a ${filteredDataLabel}`}
                                searchKeyword={search}
                            />
                        </div>
                    </Grid>
                </Grid>
            </MobileFiltersBar>
            <FilterResultsCount>
                {count !== undefined && resultsList && resultsList.length > 0 ? (
                    <Typography variant="p" className="filter-results-count">
                        {count} {count === 1 ? filteredDataLabel : filteredDataLabelPlural}{' '}
                    </Typography>
                ) : (
                    ''
                )}
            </FilterResultsCount>
        </div>
    );
};
